<template>
  <span>
    <slot>{{computedLabel}}</slot>
    <span v-if="sortable" class="caret-wrapper" :class="sortClass" @click="onClick">
      <i class="sort-caret ascending"></i>
      <i class="sort-caret descending"></i>
    </span>
  </span>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop, Inject } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppTableHeader extends AppComponent {
  // 上位のテーブルコンポーネントで公開されたテーブルデータを参照
  @Inject('_app_table') table;

  @Prop({require: true, default: null})
  prop;

  @Prop({require: false, type: Boolean, default: false})
  sortable;

  @Prop({require: false, default: null})
  label;

  /**
   * 昇順の場合はクラス名をascendingに設定する
   * 逆順の場合はクラス名をdescendingに設定する
   */
  get sortClass () {
    if (this.table.model.sortBy === this.prop + ':desc') {
      return 'descending';
    } else if (this.table.model.sortBy === this.prop + ':asc') {
      return 'ascending';
    } else {
      return null;
    }
  }

  get computedLabel () {
    // label が指定されていない場合は、プロパティ名に対応するスキーマのラベル定義を参照する。
    if (this.label === null) {
      if (this.table && this.table.schema && (this.prop in this.table.schema.props)) {
        return this.table.schema.props[this.prop].label;
      }
    }
    return this.label;
  }

  onClick () {
    this.$emit('app-event', 'require:change-sort', this, this.prop);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/table/AppTableHeader.vue